import { TemplateData } from './htmlTemplates';

export const retroVintageTemplate = {
  id: 'retro-vintage',
  name: '复古怀旧',
  description: '复古风格，适合怀旧和经典内容',
  category: 'vintage',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: linear-gradient(45deg, #f4e4bc, #e8d5b7, #d4c4a8);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 50px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', serif;
          position: relative;
          overflow: hidden;
          border: 8px solid #8b4513;
          box-shadow: inset 0 0 20px rgba(139, 69, 19, 0.3);
        }

        .cover::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 30% 30%, rgba(139, 69, 19, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 70% 70%, rgba(160, 82, 45, 0.1) 0%, transparent 50%);
          pointer-events: none;
        }

        .vintage-frame {
          position: absolute;
          top: 20px;
          left: 20px;
          right: 20px;
          bottom: 20px;
          border: 2px solid #8b4513;
          border-radius: 10px;
          box-shadow: inset 0 0 10px rgba(139, 69, 19, 0.2);
        }

        .brand-vintage {
          position: absolute;
          top: 35px;
          right: 35px;
          font-size: 14px;
          color: #8b4513;
          font-weight: bold;
          z-index: 2;
        }

        .title {
          font-size: 40px;
          font-weight: 900;
          color: #5d4037;
          text-align: center;
          line-height: 1.2;
          margin-bottom: 30px;
          letter-spacing: 1px;
          position: relative;
          z-index: 2;
          text-shadow: 2px 2px 4px rgba(139, 69, 19, 0.3);
        }

        .title-retro {
          background: linear-gradient(45deg, ${data.theme.primaryColor}, #8b4513);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          position: relative;
        }

        .title-retro::before {
          content: '';
          position: absolute;
          top: -5px;
          left: -5px;
          right: -5px;
          bottom: -5px;
          background: linear-gradient(45deg, transparent, rgba(139, 69, 19, 0.1), transparent);
          border-radius: 5px;
          z-index: -1;
        }

        .subtitle {
          font-size: 16px;
          color: #6d4c41;
          text-align: center;
          line-height: 1.5;
          font-weight: 400;
          position: relative;
          z-index: 2;
          font-style: italic;
        }

        .vintage-tag {
          background: #8b4513;
          color: #f4e4bc;
          padding: 2px 6px;
          border-radius: 3px;
          font-weight: 600;
          margin: 0 2px;
          font-style: normal;
          box-shadow: 1px 1px 3px rgba(139, 69, 19, 0.5);
        }

        .decorative-corner {
          position: absolute;
          width: 40px;
          height: 40px;
          border: 3px solid #8b4513;
        }

        .corner-tl {
          top: 40px;
          left: 40px;
          border-right: none;
          border-bottom: none;
        }

        .corner-tr {
          top: 40px;
          right: 40px;
          border-left: none;
          border-bottom: none;
        }

        .corner-bl {
          bottom: 40px;
          left: 40px;
          border-right: none;
          border-top: none;
        }

        .corner-br {
          bottom: 40px;
          right: 40px;
          border-left: none;
          border-top: none;
        }

        .vintage-ornament {
          position: absolute;
          bottom: 80px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 20px;
          background: linear-gradient(90deg, transparent, #8b4513, transparent);
          border-radius: 10px;
        }

        .vintage-ornament::before,
        .vintage-ornament::after {
          content: '';
          position: absolute;
          top: 50%;
          width: 10px;
          height: 10px;
          background: #8b4513;
          border-radius: 50%;
          transform: translateY(-50%);
        }

        .vintage-ornament::before {
          left: -15px;
        }

        .vintage-ornament::after {
          right: -15px;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="vintage-frame"></div>
        <div class="brand-vintage">${data.theme.logo}</div>
        
        <div class="decorative-corner corner-tl"></div>
        <div class="decorative-corner corner-tr"></div>
        <div class="decorative-corner corner-bl"></div>
        <div class="decorative-corner corner-br"></div>
        
        <h1 class="title">
          ${data.title.split(' ').map((word, i) => 
            i % 2 === 1 ? `<span class="title-retro">${word}</span>` : word
          ).join(' ')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{2,4})/g, '<span class="vintage-tag">$1</span>')}</p>
        
        <div class="vintage-ornament"></div>
      </div>
    </body>
    </html>
  `
};
